<template>
  <div class="wrap">
    <el-badge :is-dot="isRead" class="item">
      <el-button type="text" size="small" @click="openDrawer"
        >消息中心</el-button
      >
    </el-badge>
    <el-drawer
      :visible.sync="drawer"
      :show-close="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      :with-header="false"
    >
      <h3 class="allInfo">全部消息</h3>
      <el-row class="search">
        <el-col :span="12">
          <div>
            <el-input
              v-model="key"
              placeholder="请输入搜索关键字"
              class="input-with-select"
              size="small"
              suffix-icon="el-icon-search"
              @blur="noticeList"
            />
          </div>
        </el-col>
      </el-row>
      <div class="news">
        <div
          v-for="(i, index) in newsData"
          :key="index"
          class="items"
          @click="openClick(i)"
        >
          <el-badge :is-dot="!i.is_read" class="">{{ i.name }}</el-badge>
        </div>
      </div>
      <el-drawer :append-to-body="true" :visible.sync="innerDrawer">
        <div class="switch">
          <el-switch
            v-model="value"
            active-text="置顶"
            inactive-text="取消置顶"
            @change="handleChange"
          />
        </div>
        <!--用户被创建通知-->
        <div v-if="intoTitle === '用户被创建通知'">
          <div class="list">
            <span>用户名：</span>
            <span>{{ userNames }}</span>
          </div>
          <div class="list" style="padding: 0 20px">
            <span
              >医兰德系统已经成功为您创建了一个用户账号.请使用下面的账号信息登录医兰德系统，点击 这里 进行登录，激活您的账号。首次登录时，医兰德系统会提示您修改您的密码。</span
            >
          </div>
          <div class="list">
            <span>登录账户：</span>
            <span>{{ email }} / {{ phone }}</span>
          </div>
          <div class="list">
            <span>初始密码：</span>
            <span>123456</span>
          </div>
        </div>
        <!--用户加入项目通知-->
        <div v-if="intoTitle === '用户加入项目通知'">
          <div class="list">
            <span>用户名：</span>
            <span>{{ userNames }}</span>
          </div>
          <div class="list">
            <span>项目名称：</span>
            <span>{{ proName }}</span>
          </div>
        </div>
        <!--盲底使用通知-->
        <div v-if="intoTitle === '盲底使用通知'">
          <div class="list">
            <span>用户名：</span>
            <span>{{ userNames }}</span>
          </div>
          <div class="list">
            <span>您参加的：</span>
            <span>{{ proName }}项目盲底已被正式使用</span>
          </div>
        </div>
        <!--受试者登记-->
        <div
          v-if="
            intoTitle === '受试者登记通知' ||
            intoTitle === '受试者脱落通知' ||
            intoTitle === '紧急揭盲通知'
          "
        >
          <div class="list">
            <span>项目名称：</span>
            <span>{{ proName }}</span>
          </div>
          <div class="list">
            <span>临床试验方案：</span>
            <span>{{ clinical_trials_code }}</span>
          </div>
          <div class="list">
            <span>研究中心：</span>
            <span>{{ unit_name }}</span>
          </div>
          <div class="list">
            <span>研究者：</span>
            <span>{{ doctor_name }}</span>
          </div>
          <div class="list">
            <span>筛选号：</span>
            <span>{{ choice_code }}</span>
          </div>
          <div class="list">
            <span>姓名缩写：</span>
            <span>{{ name_abb }}</span>
          </div>
          <div class="list">
            <span>分层设置：</span>
            <span>{{ layer_str }}</span>
          </div>
           <div class="list">
            <span>{{proId==='62f9f0dcc43d533bd20f99a1'?'组别':'试验组名'}}：</span>
            <span>{{ group_name }}</span>
          </div>
          <div class="list">
            <span>登记人员：</span>
            <span>{{ action_user }}</span>
          </div>
          <div class="list" v-if="proId!=='62f9f0dcc43d533bd20f99a1'">
            <span>入组时间：</span>
            <span>{{ create_time_short }}</span>
          </div>
          <div v-if="intoTitle === '受试者脱落通知'" class="list">
            <span>脱落原因：</span>
            <span>{{ fall_off_reason }}</span>
          </div>
          <div v-if="intoTitle === '紧急揭盲通知'" class="list">
            <span>揭盲原因：</span>
            <span>{{ urgently_unblind_reason }}</span>
          </div>
        </div>
        <!--揭盲通知-->
        <div v-if="intoTitle === '一级揭盲通知'">
          <div class="list">
            <span>用户名：</span>
            <span>{{ userNames }}</span>
          </div>
          <div class="list">
            <span>您参加的：</span>
            <span>{{ proName }}项目已经完成（一级）揭盲</span>
          </div>
        </div>
        <div v-if="intoTitle === '二级揭盲通知'">
          <div class="list">
            <span>用户名：</span>
            <span>{{ userNames }}</span>
          </div>
          <div class="list">
            <span>您参加的：</span>
            <span>{{ proName }}项目已经完成（二级）揭盲</span>
          </div>
        </div>
        <!--项目状态变更通知-->
        <div v-if="intoTitle === '项目状态变更通知'">
          <div class="list">
            <span>用户名：</span>
            <span>{{ userNames }}</span>
          </div>
          <div class="list">
            <span>您参加的：</span>
            <span>{{ proName }}项目状态变更 ({{ project_status }})</span>
          </div>
        </div>
      </el-drawer>
    </el-drawer>
  </div>
</template>

<script>
import { top, cancelTop, readInfo, noticeList } from "@/api/newsCenter";
import {getProjectId} from '@/utils/auth'
export default {
  name: "Index",
  props: {
    newsData: {
      type: Array,
    },
    isReadNum: {
      type: Number,
    },
  },
  data() {
    return {
      drawer: false,
      proId:"",
      key: "",
      count: 100,
      innerDrawer: false,
      detail: null,
      userNames: "",
      email: "",
      phone: "",
      url: "",
      proName: "",
      fall_off_reason: "",
      urgently_unblind_reason: "",
      project_status: "",
      unit_name: "",
      doctor_name: "",
      name_abb: "",
      choice_code: "",
      create_user_name: "",
      random_code_combination: "",
      layer_str: "",
      group_name: "",
      create_time_short: "",
      value: false,
      newsId: "",
      top: null, // 大于0置顶
      isRead: false,
      intoTitle: "",
      clinical_trials_code:"",
      action_user:""//操作人员
    };
  },
  created() {
    this.proId = getProjectId();
    if (this.isReadNum > 0) {
      console.log(this.isReadNum);
      this.isRead = true;
    } else {
      this.isRead = false;
    }
  },
  methods: {
    noticeList() {
      noticeList({ key: this.key })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.newsData = res.data;
            } else {
              this.newsData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    openDrawer() {
      this.drawer = true;
    },
    openClick(obj) {
      readInfo({ id: obj.id })
        .then((res) => {
          if (res && res.code === 0) {
            // console.log('读取成功')
            this.$parent.noticeList();
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
      this.top = obj.top;
      if (obj.top > 0) {
        this.value = true;
      } else {
        this.value = false;
      }
      console.log(obj);
      this.intoTitle = obj.name;
      if (obj.project_user) {
        this.userNames = JSON.parse(sessionStorage.getItem("iwrs_user")).name;
        this.email = obj.project_user.email;
        this.phone = obj.project_user.phone;
      }
      if (obj.project) {
        this.proName = obj.project.name;
        this.clinical_trials_code = obj.project.clinical_trials_code;
        this.project_status = obj.project.project_status;
      }
      if(obj.to_user){
        this.action_user=obj.to_user.name;
      }
      this.url = obj.url;
      this.newsId = obj.id;
      // console.log(obj)
      this.innerDrawer = true;
      this.unit_name = obj.subject.unit_name;
      this.doctor_name = obj.subject.doctor_name;

      this.urgently_unblind_reason = obj.subject.urgently_unblind_reason;
      this.fall_off_reason = obj.subject.fall_off_reason;
      this.name_abb = obj.subject.name_abb;
      this.choice_code = obj.subject.choice_code;
      this.create_user_name = obj.subject.create_user_name;
      this.random_code_combination = obj.subject.random_code_combination;
      this.layer_str = obj.subject.layer_str;
      this.group_name = obj.subject.group_name;
      this.create_time_short = obj.subject.create_time_short;
    },
    handleChange(val) {
      console.log(val);
      if (val) {
        console.log("置顶");
        this.settingTop();
      } else {
        console.log("取消置顶顶");
        this.cancelTop();
      }
    },
    // 置顶
    settingTop() {
      top({ id: this.newsId })
        .then((res) => {
          if (res && res.code === 0) {
            this.$parent.noticeList();
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    // 取消置顶
    cancelTop() {
      cancelTop({ id: this.newsId })
        .then((res) => {
          if (res && res.code === 0) {
            this.$parent.noticeList();
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
  },
};
</script>

<style scoped>
.item {
  /*margin-top: 10px;*/
  margin-right: 40px;
  margin-bottom: 30px;
}
.allInfo {
  padding: 10px 0;
  text-align: center;
  background-color: #d6e4ff;
  color: #595959;
}
.search {
  margin: 20px;
}
.news {
  overflow-y: auto;
  height: 80%;
  /*border: 1px solid red;*/
  margin-bottom: 50px;
  position: absolute;
  width: 100%;
}
.items {
  padding: 20px 20px;
  /*border-top:1px solid #D6E4FF;*/
  border-bottom: 1px solid #d6e4ff;
  /*background-color: #698CFC;*/
  margin: 5px;
  width: 500px;
  cursor: pointer;
}
.list {
  /*border: 1px solid red;*/
  padding: 15px 0;
  text-align: center;
}
.switch {
  text-align: right;
  margin-right: 10px;
}
</style>
